<ul class="navbar-nav">
  <li>
    <div class="dropdown drp-user" ngbDropdown placement="auto">
      <a href="javascript:" ngbDropdownToggle data-toggle="dropdown">
        <i class="icon feather icon-settings"></i>
      </a>
      <div class="dropdown-menu dropdown-menu-end profile-notification" ngbDropdownMenu>
        <div class="pro-head d-flex align-items-start">
          <img src="assets/images/user/usuario.png" class="img-radius profile-img" alt="User-Profile-Image" />
          <div class="user-info">
            <span class="form-control-sm user-fullname">{{ usuario }}</span>
          </div>
          <a href="" class="dud-logout ms-auto" title="Logout" (click)="clickLogOut()">
            <i class="feather icon-log-out"></i>
          </a>
        </div>
        <ul class="pro-body">
          <!--<li>
            <a href="" class="dropdown-item"><i class="feather icon-lock" (click)="clickChangePassword"></i>Cambiar contraseña</a>
          </li>-->
        </ul>
      </div>
    </div>
  </li>
</ul>